<template>
  <v-container fluid class="no-border-container">
    <div :class="paginatedItems.length === 7 ? 'table_area_box' : 'table_area_box_empty'">
      <v-card-text>
        <v-layout>
          <v-spacer></v-spacer>
      <v-flex xs1>
      <v-btn small color="secondary" @click="getReport"> Export </v-btn>
      </v-flex>
          <v-spacer>
          </v-spacer>
          <v-flex xs3>
            <v-text-field label="Search" v-model="search">
            </v-text-field>
          </v-flex>
        </v-layout>

        <table class="table ">
          <thead class="thead">
          <tr>
            <th scope="col">Date</th>
            <th scope="col">Loan ID</th>
            <th scope="col">Grower Code</th>
            <th scope="col">Farmer Name</th>
            <th scope="col">Farmer ID No</th>
            <th scope="col">Season</th>
            <th scope="col">Disbursement Ref</th>
            <th scope="col">Loan Amount</th>
            <th scope="col">Recovery Status</th>
<!--            <th scope="col">RecoveredAmount</th>-->
<!--            <th scope="col">Date Recovered</th>-->
<!--            <th scope="col">Recovery Ref</th>-->

          </tr>
          </thead>
          <tbody>
          <tr v-for="item in paginatedItems" v-bind:key="item.id">
            <td> {{ item.loan.dateRequested }}</td>
            <td> {{ item.loan.loanId }}</td>
            <td> {{ item.loan.growerCode }}</td>
            <td> {{ item.farmer.fullName }}</td>
            <td> {{ item.farmer.farmerId }}</td>
            <td> {{ item.loan.season }}</td>
            <td> {{ item.internalFtRef }}</td>
            <td> {{ item.loan.loanAmount }}</td>
            <td> {{ item.loan.recoveryStatus.statusName }}</td>

<!--            <td> {{ item.loan.recoveredAmount }}</td>-->
<!--            <td> {{ item.loan.dateRecovered }}</td>-->
<!--            <td> {{ item.loan.paymentRef }}</td>-->
          </tr>
          </tbody>
        </table>
      </v-card-text>
      <v-card-actions>
        <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
        <v-spacer></v-spacer>
        <v-pagination
          v-model="page"
          :length="numberOfLinks"
          :total-visible="7"
          color="secondary"
                class="accent--text logoutbtn"
        ></v-pagination>
      </v-card-actions>
    </div>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
	name: 'disbursedLoans',
	data: function () {
		return {
			tab: null,
			items: [],
			message: '',
			loading: false,
			snackbar: false,
			snackbarColor: '',
			messsage: '',
			paginatedItems: [],
			permissions: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			currentPage: 0,
			page: 1
		}
	},
	watch: {
		items: function () {
			this.paginatedItems = this.items
		},
		page: function (val) {
			this.paginatedItems = this.getLoanRequests(val - 1)
		}
	},
	mounted () {
		this.getLoggedInUser()
		this.getLoanRequests(this.currentPage)

		this.permissions = store.state.user.roleId.permissions
	},
	methods: {

		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		getLoggedInUser () {
			this.theUser = JSON.parse(localStorage.getItem('user'))
			console.log('user ===>> ', this.theUser)
			this.organisationType = this.theUser.organisation.organisationType.name
			this.organisationId = this.theUser.organisation.id
			// this.curUserN = this.curUser.firstName
		},
    getReport () {
			const url = config.serverURI + '/disbursement/download/'+this.organisationId
			axios({ url: url, method: 'GET', responseType: 'blob' })
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = 'loantransactions.csv'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		getLoanRequests (page) {
			var url = config.serverURI + '/loan/requests/' + this.organisationId + '?page=' + page + '&size=' + this.numberOfItemsPerPage + '&status=SUCCESS'
			axios.get(url)
				.then(response => {
					console.log(response.data)
					this.items = response.data.data
					this.numberOfLinks = response.data.page.totalPages
					this.numberOfItemsPerPage = response.data.page.size
					this.currentPage = response.data.page.number
				})
				.catch(error => {
					this.$store.dispatch('alert/displayAlert', {
						snackbar: true,
						color: 'error',
						message: error.response.data ? error.response.data.message : 'Error ocurred'
					})
				})
			return this.items
		}

	}
}

</script>
<style scoped>

.table_area_box_empty {
  position: relative;
  background: #fff;
  overflow-x: auto;
  /* //border: 1px solid #707070; */
}

.table_area_box {
  position: relative;
  background: #fff;
  overflow-x: auto;
/* //border: 1px solid #707070; */

}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}

.pagination {
  background-color: red;
}

.paginationtext {
  color: #733D29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}

.pagination > li.active > .page-link {
  background: #00513B;
  color: #fff;
}

.table {
  overflow-x: auto;
}

td {
  max-width: 200px; /* Set a maximum width for cells */
  overflow: hidden;
  text-overflow: ellipsis; /* Show ellipsis (...) for text overflow */
  white-space: nowrap; /* Prevent text from wrapping */

}
</style>
